// extracted by mini-css-extract-plugin
export var inlineLink = "_4c-0";
export var inlineLinkButton = "_4c-1";